import { Table } from "antd";
import React from "react";
import { Col, Row } from "reactstrap";

const FDetailAssistance=({assistance})=> {

    const columns = [
        {
            title: 'N°',
            dataIndex: 'id',
            key: 'id',
            render: (item, _)=> {
                return (
                    <div>{item}</div>
                )
            }
        },
        {
            title: 'Assistance',
            dataIndex: 'guaranteeName',
            key: 'guaranteeName',
        },
    ];

    return (
        <React.Fragment>
            <Row>

                <Col lg={12}>
                    <Table
                        /* loading={isFlotteQuotationLoading}*/
                        columns= {columns} 
                        dataSource= {assistance?.assistanceLines}
                        title={() => assistance?.title}
                        pagination= {{ position: ["bottomRight"], pageSize: 2}}
                    />
                </Col>
            </Row>
        </React.Fragment>
    )
}

export default FDetailAssistance;